var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fab-button-whatsapp",attrs:{"href":_vm.url,"id":"fab-button-wh","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":require('../assets/whatsapp.svg'),"alt":"Whatsapp"}})])}
var staticRenderFns = []

export { render, staticRenderFns }